let _cb = null;

if (!_cb) {
    _cb = window.Chargebee.init({ 
        site: 'towersystems', 
        publishableKey: 'live_SEObLJcLvRsCCBqh5W3cupvWT38Hcda6T0' 
        // site: 'towersystems-test', 
        // publishableKey: 'test_CcujOzrYiOfkIa0Q29v9fwRDYe64NbI15' 
    });
}

export default _cb;
